// extracted by mini-css-extract-plugin
module.exports = {"select":"FormSelect_select_33pml","label":"FormSelect_label_2W1lJ","required":"FormSelect_required_ije35","error":"FormSelect_error_37_up"};